export var FREE_TRIAL_DURATION = 7;